import React from 'react';

const Demo = () => {
  return (
    <section id="demo" className="video">
      <div className="container">
        <h2 className="section-title">Demo Video</h2>
        <p className="section-sub">A quick walkthrough of the Ilmium experience in action.</p>
        <div className="video-wrap">
          <video
            controls
            preload="metadata"
            playsInline
            className="demo-player"
          >
            <source src="Screen%20Recording%202025-10-15%20at%2020.47.15.mp4" type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
      </div>
    </section>
  );
};

export default Demo;
